module.exports = __webpack_public_path__ + "static/reformas-e7fc5ab7583a37771d000133ee6849f2.jpg";